import * as React from 'react';

const HiddenIcon = () => (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
        <path
            d="M1.585 6.5843L0 4.9993L2.465 2.5343C3.695 1.3043 5.41 0.849297
        7 1.1743L1.585 6.5843ZM12 4.9993L9.535 7.4643C7.89 9.1093 5.385 9.3643
        3.47 8.2343L1.85 9.8543L1.145 9.1493L2.655 7.6393L4.28 6.0143L7.005 3.2893L8.525
         1.7693L10.14 0.154297L10.845 0.859297L9.335 2.3693C9.4 2.4243 9.47 2.4793 9.53
          2.5393L12 4.9993ZM8 4.9993C8 4.6293 7.895 4.2843 7.72 3.9843L4.985 6.7193C5.285
           6.8943 5.63 6.9993 6 6.9993C7.105 6.9993 8 6.1043 8 4.9993Z"
        />
    </svg>
);

export default HiddenIcon;
